/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect, Children } from 'react';
import { Field } from 'formik';
import InputField from 'components/Form/InputField';
import { GlobalAuthContext } from 'store/context';
import MasksHelper from 'utils/src/masks';
import ComboBox from 'components/Form/ComboBox3';
import SearchField from 'components/Form/SearchField';
import _, { camelCase, isObject } from 'lodash';
import {DayPicker} from 'react-day-picker';
import Label from 'components/Form/Label';
import Switch from 'react-switch';
import Colors from 'constants/Colors';
import { FitinsurAPI, MessageCenter } from 'utils';
import TextField from 'components/Form/TextField';
import Icon from 'components/Icon';
import DialogEditPerson from 'components/DialogEditPerson';
import Person from '../../flows/base/pages/person';
import { TextEditorBox } from 'components/index';
import moment from 'moment';

import { FieldWrapper, Container, CalendarContainer, BorderSwitch, AddButton } from './styles'

const fitinsurApi = new FitinsurAPI();

const getMask = (question, authContext) => {
  const masks = new MasksHelper();

  const { behaviorObject } = question;
  if (behaviorObject) {
    if (behaviorObject && behaviorObject.fieldMask) {
      const { fieldMask, fieldMaskScale, fieldMaxValue, fieldMinValue, fieldMaskLength } = behaviorObject;
      if (fieldMask == "percentage") {
        return masks.getPercentage(authContext.region, fieldMaskScale || null, fieldMaxValue || "9999", fieldMinValue || "0");
      } else if (fieldMask === 'monthYear'){
        
        return masks.getMonthYearMask();
      } else {
        return masks.getMask(fieldMask || null, authContext.region, fieldMaskScale || null, fieldMaskLength || null, fieldMaxValue || null, fieldMinValue || null)
      }
    }
  }

  return null;
}

const getFieldComponent = (question) => {
  const { idDomainQuestion, idQuestion, behaviorObject } = question;

  //first if: refactor bahavior
  if (idQuestion === 77) {
    return TextField;
  } else if (idDomainQuestion === 42) {
    switch (behaviorObject?.componentId) {
      case "TextEditorBox": return TextEditorBox;
      default: return InputField;
    }
  } else if (idDomainQuestion == 43) {
    return ComboBox;
  } else if (idDomainQuestion === 276) {
    return SearchField;
  } else if (idDomainQuestion === 295) {
    return InputField;
  } else if (idDomainQuestion === 277) {
    return InputField;
  }
}

const getOptions = (question, idProduct) => {
  if (question.idDomainQuestion !== 43) return [];

  if (question.answerOptions) {
    const answerOptions = question.answerOptions.map(answerOption => {
      let behavior = {}
      try {
        behavior = JSON.parse(answerOption.behaviorAnswerOption)
      } catch (e) {
        console.error('GET OPTIONS - Error in parse Behavior')
      }

      if (behavior?.isResultProduct || behavior?.isResultPerson) {
        const hasProduct = behavior.resultIdProduct?.some(resultId => resultId == idProduct);

        if (hasProduct) {
          return {
            label: answerOption.dsAnswerOption,
            answerOptionExpireDate: answerOption.answerOptionExpireDate,
            value: {
              idAnswerOption: answerOption.idAnswerOption,
              dsAnswerOption: answerOption.dsAnswerOption,
              ...(question.idQuestion === 112 ? { behavior } : {})
            }
          }
        }
      } else {
        return {
          label: answerOption.dsAnswerOption,
          answerOptionExpireDate: answerOption.answerOptionExpireDate,
          value: {
            idAnswerOption: answerOption.idAnswerOption,
            dsAnswerOption: answerOption.dsAnswerOption,
            ...(question.idQuestion === 112 ? { behavior } : {})
          }
        }
      }
    })

    return answerOptions.filter(Boolean);
  }

  return [];
}


const getQuestionAnswer = (question, setFieldValue) => {
  if (!question) return '';

  //question with options answer
  if (
    question.idAnswerOption &&
    'answerOptions' in question &&
    question.behaviorObject.searchQueryId !== 'fitGetCurrencies'
    && question.idDomainQuestion === 43
  ) {
    let dsAnswerOption;
    try {
      dsAnswerOption = question?.answerOptions?.find(x => x.idAnswerOption == question?.idAnswerOption).dsAnswerOption;
    } catch (err) {
      console.error(`quotation-edit - checkType: idAnswerOption: ${question.idAnswerOption} - ERROR: ${err.message}`);
    }

    if (!question.answer && dsAnswerOption) question.answer = dsAnswerOption || ''
    setFieldValue && setFieldValue(question.key, {
      idAnswerOption: question?.idAnswerOption,
      dsAnswerOption: dsAnswerOption || ''
    });
    return;
  }

  if (question.behaviorObject.rightIcon === "calendar") {
    let formattedDate = "";
    if (question.answer) {
      let momentDate = moment(question.answer, 'DD/MM/YYYY');
      if (momentDate.isValid()) {
        formattedDate = momentDate.format("DD/MM/YYYY");
        question.answer = momentDate.format("DD/MM/YYYY");
      }
    }

    setFieldValue && setFieldValue(question.key, formattedDate)
  }

  //question with string or json answer
  try {
    let answerJson = JSON.parse(question.answerJson);

    if (answerJson && answerJson.constructor === Object) {
      setFieldValue && setFieldValue(question.key, answerJson?.namePerson || answerJson?.personName || '');
      return;
    } else {
      setFieldValue && setFieldValue(question.key, question?.answer || '');
      return;
    }
  } catch (error) {
    console.log('ERROR IN PARSE', question);
    setFieldValue && setFieldValue(question.key, question?.answer || '');
    return;
  }
}

const returnQuestionAnswer = (question) => {
  if (!question) return '';

  //question with options answer
  if (question.idAnswerOption && 'answerOptions' in question) {
    let dsAnswerOption;
    try {
      dsAnswerOption = question?.answerOptions?.find(x => x.idAnswerOption == question?.idAnswerOption).dsAnswerOption;
    } catch (err) {
      console.error(`quotation-edit - checkType: idAnswerOption: ${question.idAnswerOption} - ERROR: ${err.message}`);
    }

    if (!question.answer && dsAnswerOption) question.answer = dsAnswerOption || ''
    return question.answer
  }

  //question with string or json answer
  try {
    let answerJson = JSON.parse(question.answerJson);
    if (answerJson && answerJson.constructor === Object) {
      return answerJson?.namePerson || answerJson?.personName || ''
    } else {
      return question?.answer
    }
  } catch {
    return question?.answer || ''
  }
}
let questionDescription;

export default function FormSection({
  isToggleActived,
  changeStateOfToggle,
  sectionName,
  questionnaire,
  onCurrentClientChange,
  externalFormCurrentClient,
  values,
  setFieldValue,
  sectionIndex,
  extraButtons,
  onQuestionChange,
  renderAttachments,
  renderUploadButton,
  idOperationParent,
  hasPermission,
  idProduct,
  uxecuteInTheBeginning,
  isSelectMarketsScreen,
  partiesIndex,
  onRiskQuestionnaire
}) {
  const authContext = useContext(GlobalAuthContext);
  const [searchList, setSearchList] = useState([]);
  const [filteredQuestionnaire, setFilteredQuestionnaire] = useState([]);
  const [showCalendar, setShowCalendar] = useState("");
  const [idPerson, setIdPerson] = useState(null);
  const isMultipleFormSection = sectionIndex != null;


  const goToRegisterPerson = (question) => {
    if (question) {
      try {
        const answerJson = JSON.parse(question.answerJson);
        const idPerson = answerJson.id || answerJson.idPerson;
        return window.open(`/fitinsur-texel/management/person/${idPerson || ""}`, '_blank');
      } catch (e) {
        return window.open(`/fitinsur-texel/management/person/`, '_blank');
      }
    }

    window.open(`/fitinsur-texel/management/person/`, '_blank');
  };

  //search request for search field types based on behavior
  const searchRequest = (searchValue, queryId) => {
    try {
      if (!queryId) return;

      let clientQuestionAnswerJson = {};
      try {
        clientQuestionAnswerJson = JSON.parse(externalFormCurrentClient?.answerJson);
      } catch (e) {
        clientQuestionAnswerJson = {};
      }

      fitinsurApi.setAuthToken(authContext.token);
      fitinsurApi.requestPersonList(queryId, {
        id: queryId,
        personName: searchValue,
        idProduct: idProduct,
        idPerson: externalFormCurrentClient?.id || externalFormCurrentClient?.idPerson || (clientQuestionAnswerJson.id || clientQuestionAnswerJson.idPerson),
        idOperationParent,
        isSelectMarketsScreen
      }).then((response) => response.json())
        .then((data) => {
          if (data.ret_code != 200) {
            return;
          }

          if (queryId === 'fitGetPersonBrokerByClient') {
            data.ret_value = data.ret_value?.map(v => ({ ...v, id: v.idPersonUser, personName: `${v.nmPersonBroker}` }))
            const listBroker = data.ret_value?.sort((first, next) => String(first.personName).localeCompare(String(next.personName)))
            setSearchList(listBroker);
            return;
          } else if (queryId === 'fitGetCurrencies') {
            const currencies = data.ret_value.map(currency => ({
              value: currency.currencyCode,
              id: currency.idCurrency
            }));

            setSearchList(currencies);
            return;
          }
          setSearchList(data.ret_value);
        });
    } catch (err) {
      console.log("FETCH_FAILURE: ", err);
    }
  }

  //observer filter questions based on behavior when questionnare is loaded or change
  useEffect(() => { 
    const filteredQuestionnaire = questionnaire
      .filter(question => {
        return question.visibleQuestion && question.behaviorObject && question.behaviorObject.sectionName === sectionName;
      })
      .map(question => {
        if (!question.key) question.key = `${camelCase(question.dsQuestion)}${isMultipleFormSection ? `_${sectionIndex}` : ""}`;
        if(question.idQuestion != 498){
          getQuestionAnswer(question, setFieldValue);
        }else{
            getQuestionAnswer(questionDescription ? questionDescription : question, setFieldValue);
            // if(questionDescription && !questionDescription.answerJson){
            //   getQuestionAnswer(question, setFieldValue);
            // }
        }
          if (question.idQuestion === 59 && returnQuestionAnswer(question)) {
            setCurrentClient(question);
        }

        return question
      })
      setFilteredQuestionnaire(filteredQuestionnaire);
    uxecuteInTheBeginning && uxecuteInTheBeginning(filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue)

  }, [questionnaire]);

  //Send current client externaly to other forms
  const setCurrentClient = (currentClient) => {
    if (onCurrentClientChange) {
      onCurrentClientChange(currentClient);

      const brokerQuestion = questionnaire.find(question => question.idQuestion === 109);
      setFieldValue && setFieldValue(`${brokerQuestion?.key}`, '');

      if(onRiskQuestionnaire && onRiskQuestionnaire.length) {
        for(const riskQuestion of onRiskQuestionnaire) {
          const insuredLegalEntityQuestion = riskQuestion.find(question => question.idQuestion === 60);
          setFieldValue && setFieldValue(`${insuredLegalEntityQuestion?.key}`, '');
        }
      }
    }
  };

  //observer to send current questionnaire answers externally to other forms
  useEffect(() => {
    // console.log(`$ANSWERS_${sectionName}${sectionIndex != null ? `_${sectionIndex}` : ""}`, filteredQuestionnaire, values)
    setFieldValue(`$ANSWERS_${sectionName}${sectionIndex != null ? `_${sectionIndex}` : ""}`, filteredQuestionnaire);
  }, [filteredQuestionnaire]);

  const isDisabledIfNoClient = (questionId) => {
    // Array with questions that must be disabled if client is not selected
    const questions = [60, 109, 139];

    if (questions.includes(questionId) && !externalFormCurrentClient) return true
    return false;
  }

  return (
    <Container>
      {partiesIndex ? (
        <Label
          style={{display: 'inline-flex', alignItems: 'center', padding: 15}}
          fontSize={20}>
          {partiesIndex}.
        </Label>
      ): ''}
      {filteredQuestionnaire.map((question, index) => {
        return (
          <React.Fragment key={`QUESTION-${question?.idQuestion}-${index}`}>
            <FieldWrapper
              flex={question.idQuestion === 119}
              borderTop={question.idQuestion === 119}
              mobileWidth={question.behaviorObject.mobileWidth}
              tabletWidth={question.behaviorObject.tabletWidth}
              desktopWidth={question.behaviorObject.desktopWidth}
            >
              {/* if question is type text, number, search or select */}
              {question.idQuestion !== 112 && question.behaviorObject.componentId !== 'Switch' ?
                <Field
                  disabled={values.lock || question.disabled}
                  readOnly={question.behaviorObject.isReadOnly || isDisabledIfNoClient(question.idQuestion)}
                  mask={getMask(question, authContext)}
                  isRequired={question.behaviorObject.isRequired}
                  name={question.key}
                  label={question.dsQuestion}
                  placeholder={isDisabledIfNoClient(question.idQuestion) ? (question.idQuestion === 139 ? 'Waiting for surplus broker' : 'Waiting for client') : ''}
                  type="text"
                  leftIcon={question.behaviorObject.leftIcon}
                  leftIconText={question.behaviorObject.leftIconText || filteredQuestionnaire.map(question => {
                    if (question.idQuestion === 68 && question.answer) {
                      if (question.answer.length === 3)
                        return question.answer
                      else if (question.answer.length > 3)
                        return JSON.parse(question.answer).value
                      else
                        return ''
                    }
                  })}
                  rightIcon={question.behaviorObject.rightIcon}
                  rightIconClick={() => {
                    if (question.behaviorObject.rightIcon === 'calendar' && !question.behaviorObject.disable) return setShowCalendar(!showCalendar.trim().length ? question.key : '')
                  }}
                  component={getFieldComponent(question)}
                  options={getOptions(question, idProduct)}
                  value={values && values[question.key]}
                  searchList={isDisabledIfNoClient(question.idQuestion) ? [] : searchList}
                  onChange={(value) => {
                    if (question.idQuestion === 498 && question.answer) {
                      question.answer = value
                      questionDescription = question
                    }
                    setFieldValue && setFieldValue(question.key, value, false);
                    searchRequest(value, question.behaviorObject.searchQueryId);
                    let filteredQuestionnaireUpdated = filteredQuestionnaire;

                    if (!question.behaviorObject.searchQueryId || value === '') {
                      const idAnswerOption = isObject(value) && value.idAnswerOption ? value.idAnswerOption : undefined;
                      const answer = idAnswerOption ? value.dsAnswerOption : isObject(value) ? JSON.stringify(value) : value;
                      filteredQuestionnaireUpdated = filteredQuestionnaire.map(v => v.key === question.key ?
                        ({
                          ...v, idAnswerOption,
                          answer: answer === '' ? v.answerJson = '' : answer,
                          answerJson: idAnswerOption ? undefined : v.answerJson
                        }) : v)

                      setFilteredQuestionnaire(filteredQuestionnaireUpdated);
                    }
                    if (question.idQuestion === 59) setCurrentClient(null)
                    onQuestionChange && onQuestionChange(question, value, filteredQuestionnaireUpdated, setFilteredQuestionnaire, setFieldValue)

                  }}
                  onFocus={() => {
                    setSearchList([])
                    searchRequest(values && values[question.key] || "", question.behaviorObject.searchQueryId)
                  }}
                  canGenerate={false}
                  onSearchSelect={(selectedValue) => {
                    if (selectedValue) {
                      const filteredQuestionnaireUpdated = filteredQuestionnaire.map(v => v.key === question.key ? ({
                        ...v, answerJson: JSON.stringify(selectedValue),
                        answer: JSON.stringify(selectedValue)
                      }) : v)

                      setFilteredQuestionnaire(filteredQuestionnaireUpdated);
                      onQuestionChange && onQuestionChange(question, selectedValue, filteredQuestionnaireUpdated, setFilteredQuestionnaire, setFieldValue)
                    }
                    if (question.idQuestion === 59) setCurrentClient(selectedValue);
                    setSearchList([]);
                  }}
                /> : <></>
              }
              {showCalendar && showCalendar === question.key ?
                <CalendarContainer>
                  <DayPicker style
                    disabledDays={[question.idQuestion === 76 ? { before: new Date() } : {}]}
                    fixedWeeks
                    onDayClick={(date) => {
                      if (question.idQuestion !== 76) {
                        date = new Date(date) || null
                      } else {
                        date = new Date(date) ? new Date(date) <= new Date() ? new Date() : new Date(date) : null;
                      }
                      let formattedDate = "";
                      let selectedDate = "";
                      let momentDate = moment(new Date(date));
                      if (momentDate.isValid()) {
                        formattedDate = momentDate.format("DD/MM/YYYY");
                        selectedDate = momentDate.format("DD/MM/YYYY");
                      }

                      setFieldValue && setFieldValue(question.key, formattedDate);
                      let filteredQuestionnaireUpdated = filteredQuestionnaire.map((v) => v.key === question.key ? { ...v, answer: selectedDate, unmaskedValue: selectedDate } : v);
                      setFilteredQuestionnaire(filteredQuestionnaireUpdated);
                      setShowCalendar("");

                      onQuestionChange && onQuestionChange(question, formattedDate, selectedDate, filteredQuestionnaireUpdated, setFilteredQuestionnaire, setFieldValue);
                    }}
                  ></DayPicker>
                </CalendarContainer>
                : <></>
              }

              {/* if question is type switch (yes or no) */}
              {question.behaviorObject.componentId === 'Switch' ?
                <>
                  <Label style={{ marginRight: 10 }}>{question.dsQuestion}</Label>
                  <BorderSwitch>
                    <Switch
                      disabled={question.disabled}
                      height={27}
                      width={53}
                      isToggleActived={
                        isToggleActived ?
                          isToggleActived(
                            values &&
                            (values[question.key] === 'YES' || values[question.key].dsAnswerOption === 'YES') &&
                            question.idQuestion === 119 &&
                            question.idQuestionnaire === 10
                          ) : null
                      }
                      checked={values && (values[question.key] === 'YES' || values[question.key].dsAnswerOption === 'YES')}
                      onChange={(value) => {
                        const answerOption = value
                          ? question.answerOptions.find(v => v.dsAnswerOption === "YES")
                          : question.answerOptions.find(v => v.dsAnswerOption === "NO");

                        if (value === true && question.idQuestion === 119 && question.idQuestionnaire === 10) {
                          changeStateOfToggle(value)
                        } else if (value === false && question.idQuestion === 119 && question.idQuestionnaire === 10) {
                          changeStateOfToggle(value)
                        }

                        const filteredQuestionnaireUpdated = filteredQuestionnaire.map(v => v.key === question.key
                          ? ({
                            ...v,
                            answer: answerOption.dsAnswerOption,
                            idAnswerOption: answerOption.idAnswerOption,
                            answerJson: undefined
                          })
                          : v
                        )
                        setFilteredQuestionnaire(filteredQuestionnaireUpdated);
                        setFieldValue && setFieldValue(question.key, answerOption.dsAnswerOption);
                        onQuestionChange && onQuestionChange(question, answerOption, filteredQuestionnaireUpdated, setFilteredQuestionnaire, setFieldValue)
                      }}
                      handleDiameter={20}
                      checkedIcon={false}
                      uncheckedIcon={false}
                      offColor={Colors.WHITE}
                      onColor={Colors.GRAY[6]}
                      offHandleColor={Colors.GRAY[6]}
                      onHandleColor={Colors.WHITE}
                    />
                  </BorderSwitch>
                </> : <></>}
            </FieldWrapper>
            {hasPermission && !!question.behaviorObject.canCreatePerson ? <AddButton style={{ paddingLeft: 8 }} onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              goToRegisterPerson(filteredQuestionnaire.find(v => {
                return v.key === question.key
              }))
            }}>
              <Icon name="addEdit" />
            </AddButton> : <></>}

            {question.idQuestion === 112 && renderUploadButton && renderUploadButton(getOptions(question))}

            {question.idQuestion === 112 && renderAttachments ? <FieldWrapper
              mobileWidth={100}
              tabletWidth={100}
              desktopWidth={100}
            >
              {renderAttachments && renderAttachments()}
            </FieldWrapper> : <></>}
          </React.Fragment>
        )
      })}
      {extraButtons && extraButtons()}
    </Container>
  );
}
